<script lang="ts">
import ModuleSupport from '@/generated/modules/ModuleSupport.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleSupport
})

</script>
